<template>
  <div class='navs'>
    <h4
    v-for='(n, i) in steps'
    :class="{active: step == i}"
    @click='$parent.jumpTo(i)'>{{n}}</h4>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: ['steps', 'step', 'title'],
  data(){
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>
  .navs {
    display: flex;
    justify-content: center;
  }

  .navs h4 {
    margin: 0 50px;
    opacity: .3;
    transition: opacity .5s, color .5s;
  }

  .navs h4.active {
    color: #ED3A4A;
    opacity: 1;
  }

</style>
